<template>
  <span class="tbl-creators__header-col whitespace-no-wrap">
    <template v-if="sortable">
      <a href="" class="flex hover:text-primary" @click.prevent="updateSorting(field)">
        <slot />
        <el-tooltip v-if="popover" class="item" effect="dark" content="tooltip" placement="top-start">
          <template slot="content">
            {{ popover }}
          </template>
          <svg class="tooltip-icon-primary flex-shrink-0" width="16" height="16">
            <use :xlink:href="`#question`"></use>
          </svg>
        </el-tooltip>
        <svg v-if="sortIcon" class="ml-1 flex-shrink-0" width="12" height="12">
          <use :xlink:href="`#${sortIcon}`"></use>
        </svg>
      </a>
    </template>
    <template v-else>
      <slot />
    </template>
  </span>
</template>
<script>
export const parseSortString = (sortString) => {
  if (!sortString) {
    return []
  }

  return sortString.split(',').map((sortParam) => {
    const [field, direction] = sortParam.split('--')
    return { field, direction }
  })
}

export default {
  props: {
    sortable: {
      type: Boolean,
      default: true,
    },
    field: {
      type: String,
      default: null,
    },
    popover: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      sort: null,
    }
  },
  computed: {
    sortIcon() {
      const sortIcon = {
        asc: 'arrow-up',
        desc: 'arrow-down',
      }
      return sortIcon[this.sort] || false
    },
  },
  created() {
    const sortParameters = parseSortString(this.$route.query.sort)
    const findSorting = sortParameters.find((item) => item.field === this.field)
    if (findSorting) {
      this.sort = findSorting.direction
    }
  },
  methods: {
    sorting() {
      this.sort = this.sort === null ? 'asc' : this.sort === 'asc' ? 'desc' : null
    },
    updateSorting(field) {
      this.sorting()
      let sortParams = this.$route.query.sort ? this.$route.query.sort.split(',') : []

      if (this.sort === null) {
        // Remove the sorting field if the direction is null.
        sortParams = sortParams.filter((p) => p.split('--')[0] !== field)
      } else {
        // Update or add the sorting field with the new direction.
        const newSortParam = `${field}--${this.sort}`
        // Remove any previous sorting entry for the same field.
        sortParams = sortParams.filter((p) => p.split('--')[0] !== field)
        // Add the new sorting entry.
        sortParams.push(newSortParam)
      }

      // Build the new query object by removing the parameters with 'null' value.
      const newQuery = { ...this.$route.query, sort: sortParams.join(',') }
      if (!sortParams.length) {
        // If we don't have any sorting parameters, remove sort from the query.
        delete newQuery.sort
      }

      // Update the URL with the new query object.
      this.$router.push({ query: newQuery })
    },
  },
}
</script>
